export default "__VITE_ASSET__CD6oeh_D__"